/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const thumbnailContainerStyle = (theme: Theme, aspectRatio?: number) => css`
  position: relative;
  overflow: hidden;
  margin: ${theme.spacing(3)} 0;
  width: 100%;
  max-width: 600px;
  height: ${aspectRatio ? `${600 / aspectRatio}px` : 'auto'};
  min-height: 200px;
  max-height: 500px;
  border-radius: ${theme.shape.borderRadius}px;
  transition: box-shadow 0.3s ease;
  margin: 0 auto;
  outline: none;
  cursor: zoom-in;

  &:hover {
    box-shadow: ${theme.shadows[4]};
  }
  &:focus-visible {
    box-shadow: ${theme.shadows[6]};
  }
`

export const thumbnailImageStyle = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-width: none !important;
  max-height: none !important;
  object-fit: cover;
  object-position: center;
  display: block;
`

export const hoverOverlayStyle = (theme: Theme) => css`
  pointer-events: none;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  opacity: 0;
  transition: opacity 150ms ease-in-out;
  border-radius: ${theme.shape.borderRadius}px;

  .MuiBox-root:hover > &,
  .MuiBox-root:focus-visible > & {
    opacity: 1;
  }
`

export const modalContainerStyle = css`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: zoom-out;
  padding: 2.5vh 2.5vw;
`

export const modalContentStyle = (theme: Theme) => css`
  position: relative;
  background: ${theme.palette.common.white};
  border-radius: ${typeof theme.shape.borderRadius === 'number'
    ? theme.shape.borderRadius * 2
    : 16}px;
  box-shadow: ${theme.shadows[12]};
  padding: 20px;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  overflow: visible;
`

export const closeButtonStyle = (theme: Theme) => css`
  position: absolute;
  top: ${theme.spacing(-3)};
  right: ${theme.spacing(-3)};
  z-index: 1;
  background: ${theme.palette.common.white};
  color: ${theme.palette.grey[700]};
  border: 1px solid ${theme.palette.grey[300]};
  box-shadow: ${theme.shadows[2]};
  cursor: pointer;

  &:hover {
    background: ${theme.palette.grey[100]};
    box-shadow: ${theme.shadows[4]};
  }

  &:focus-visible {
    outline: 2px solid ${theme.palette.primary.main};
    outline-offset: 2px;
  }
`

export const modalImageStyle = (theme: Theme) => css`
  max-width: calc(95vw - 40px);
  max-height: calc(95vh - 40px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: ${theme.shape.borderRadius}px;
  display: block;
`
